import type React from 'react';
import { useEffect } from 'react';
import { ToastContainer, type ToastItem, toast } from 'react-toastify';

export interface NotificationProps {
  containerId?: string;
  onChange?: (toast: ToastItem) => void;
  style?: React.CSSProperties;
}

export const Notification = ({
  containerId,
  onChange,
  style,
}: NotificationProps) => {
  useEffect(() => {
    if (onChange) {
      return toast.onChange(onChange);
    }

    return;
  }, [onChange]);

  return (
    <ToastContainer
      hideProgressBar
      autoClose={6000}
      enableMultiContainer
      containerId={containerId}
      style={style}
      toastClassName={() => ''}
      bodyClassName={() => ''}
    />
  );
};
